<template #messagecontainer>
</template>
<div *ngIf="showRaw.value">{{ rawContent }}</div>